import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2675">
      <div className="dark" data-id="element-2676">
        <Hero data-id="element-2677" />
      </div>
      <WhyUs data-id="element-2678" />
      <ByTheNumbers data-id="element-2679" />
      <Services data-id="element-2680" />
      <HowItWorks data-id="element-2681" />
      <FAQ data-id="element-2682" />
      <Reviews data-id="element-2683" />
      <CtaBanner data-id="element-2684" />
    </main>;
}